module.exports = __webpack_public_path__ + "img/sergeant-reason-icon4.702f3a4d.png";